import React from 'react';

function Home() {
  return (
    <div>
      <div className="header">
        <h1>Sarayu Urban Multi state Co-operative Credit Society</h1>
        <p>Building Trust, Creating Prosperity</p>
      </div>

      <div className="container">
        <div className="content">
          <h2>Welcome to Sarayu Urban</h2>
          <p>We are committed to providing excellent financial services to our members across multiple states. Our cooperative credit society operates with integrity, transparency, and a strong commitment to member satisfaction.</p>
          <br />
          <p>Join us today and experience the difference of community-based banking.</p>
        </div>
      </div>
    </div>
  );
}

export default Home;